export const CHANGE_INDEX = 'CHANGE_INDEX'
export const CHANGE_TRAINING_SET = 'CHANGE_TRAINING_SET'
export const CHANGE_HYPERPLANE = 'CHANGE_HYPERPLANE'
export const CHANGE_LEARNING_RATE = 'CHANGE_LEARNING_RATE'
export const UPDATE_EPOCH = 'UPDATE_EPOCH'
export const TRAIN = 'TRAIN'
export const CHANGE_TAB_INDEX = 'CHANGE_TAB_INDEX'
export const CHANGE_CALCULATED = 'CHANGE_CALCULATED'
export const CHANGE_SNACKBAR = 'CHANGE_SNACKBAR'
export const TOGGLE_SNACKBAR = 'TOGGLE_SNACKBAR'
export const TOGGLE_SHOW_NEXT = 'TOGGLE_SHOW_NEXT'